import { z } from 'zod';

import { meetingBlockSchema } from './meeting-block.js';

export const classTimeTypeSchema = z.enum(['recurring', 'one_time']);
export const ClassTimeType = classTimeTypeSchema.enum;
export type ClassTimeType = z.infer<typeof classTimeTypeSchema>;

export const minimalClassTimeSchema = z.object({
  id: z.string(),
  type: classTimeTypeSchema,
  meetingBlocks: z.array(z.lazy(() => meetingBlockSchema)),
  scheduleId: z.string(),
});

export type MinimalClassTime = z.infer<typeof minimalClassTimeSchema>;
